/**
 * @desc 根据bom外发主键获取bom外发详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmBomOutgoingDetailResponseDto>;
export function request(bomOutNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/bom/outgoing/${bomOutNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
